import { useEffect, useState } from "react";
import axios from "axios";
import { HelpCircle, ChevronRight } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * HelpRequestsCard — recent "I need help" signals from linked learners.
 * Shows on Work Mode entry so instructors can shape today's lesson around
 * what their pupil flagged at home.
 */
export default function HelpRequestsCard() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/api/learn-mode/help-requests/for-instructor?days=30`,
          { withCredentials: true });
        setItems(data.items || []);
      } catch { /* silent */ }
      setLoading(false);
    })();
  }, []);

  if (loading || items.length === 0) return null;

  return (
    <div data-testid="help-requests-card" className="rounded-2xl bg-amber-900/20 border border-amber-700/40 p-3 mb-2">
      <div className="flex items-center gap-2 mb-2">
        <HelpCircle className="w-4 h-4 text-amber-300" />
        <p className="text-[11px] font-extrabold uppercase tracking-wider text-amber-200">Pupils asked for help</p>
        <span className="ml-auto text-[10px] font-bold text-amber-300/80">{items.length} signals</span>
      </div>
      <ul className="space-y-1">
        {items.slice(0, 5).map((it, i) => (
          <li key={i} data-testid={`help-req-${i}`} className="rounded-xl bg-slate-900/50 border border-amber-800/30 px-3 py-2 flex items-center gap-2">
            <div className="flex-1 min-w-0">
              <p className="text-[12px] font-bold text-white truncate">{it.learner_name}</p>
              <p className="text-[11px] text-amber-200 truncate">{it.scenario_title}</p>
            </div>
            <ChevronRight className="w-4 h-4 text-amber-400/60" />
          </li>
        ))}
      </ul>
      <p className="mt-2 text-[10px] text-amber-300/70">Use this as the agenda for their next lesson.</p>
    </div>
  );
}
